'use strict';

var ScopeManager = require('./noop/scope_manager');

module.exports = ScopeManager;